import { api } from '../../../../api/configs/axiosConfigs';
import { MapMarker } from '../../domain/entities/MapMarker';
import { MapMarkerRepository } from '../../domain/ports/MapMarkerRepository';
import { BoundingBox } from '../../domain/valueObjects/BoundingBox';
import { PropertySearchRequest } from '../../domain/valueObjects/PropertySearchRequest';

// Shared abort controller for cancelling in-flight requests
let abortController: AbortController | null = null;

// TODO  ask sam why he has the shared abort controller
export class ApiMapMarkerRepository implements MapMarkerRepository {
  constructor() {}

  async findMarkersInBounds(bounds: BoundingBox): Promise<MapMarker[]> {
    // Cancel any pending requests
    if (abortController) {
      abortController.abort();
    }
    // Create new controller for this request
    abortController = new AbortController();

    try {
      const response = await api.post(
        'public/map_markers_in_bounds',
        { bounds },
        { signal: abortController.signal }
      );
      return response.data
        .map(MapMarker.fromDTO)
        .filter(
          (marker: MapMarker | null): marker is MapMarker => marker !== null
        );
    } catch (error) {
      console.error('Error fetching markers in bounds:', error);
      throw error;
    }
  }

  async findMarkersInPolygon(
    polygons: GeoJSON.Feature<GeoJSON.Polygon>[]
  ): Promise<MapMarker[]> {
    // Cancel any pending requests
    if (abortController) {
      abortController.abort();
    }
    // Create new controller for this request
    abortController = new AbortController();

    try {
      console.log('***findMarkersInPolygon polygon', polygons);
      const response = await api.post(
        'public/map_markers_in_polygon',
        {
          polygons: polygons,
        },
        { signal: abortController.signal }
      );
      console.log('***findMarkersInPolygon response', response);
      return response.data
        .map(MapMarker.fromDTO)
        .filter(
          (marker: MapMarker | null): marker is MapMarker => marker !== null
        );
    } catch (error) {
      console.error('Error fetching markers in bounds:', error);
      throw error;
    }
  }

  async markerSearchRequest(
    searchRequest: PropertySearchRequest
  ): Promise<MapMarker[]> {
    // Cancel any pending requests
    if (abortController) {
      abortController.abort();
    }
    // Create new controller for this request
    abortController = new AbortController();

    try {
      const response = await api.post('public/search', searchRequest, {
        signal: abortController.signal,
      });
      return response.data
        .map(MapMarker.fromDTO)
        .filter(
          (marker: MapMarker | null): marker is MapMarker => marker !== null
        );
    } catch (error) {
      console.error('Error fetching markers in bounds:', error);
      throw error;
    }
  }
}
